/* eslint-disable no-nested-ternary */
/* eslint-disable multiline-ternary */
import styled, { css } from 'styled-components';
import { Col } from '../../../base/Grid';

export const PhotoCol = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    return css`
      && {
        padding-left: ${mediumUp ? 0 : '1rem'};
        margin-bottom: ${mediumUp ? 0 : '1.5rem'};
      }
    `;
  }}
`;

export const StyledImg = styled.img`
  ${({ theme, photoWidth }) => {
    const smallDown = theme.useMediaQuery(theme.breakpoints.down('small'));
    return css`
      width: ${(smallDown) ? '100%' : photoWidth ? `${photoWidth}%` : 'auto'};
    `;
  }}
`;
